<script setup>
/******************************************************************************
 * PageComponent: Auth
 *****************************************************************************/
import PageSection from "Components/PageSection/PageSection.vue";
import PageAuthForm from "./PageAuthForm.vue";
</script>

<template>
    <main class="page">
        <page-section
            hdl="Geben Sie uns Ihren Zählerstand einfach online durch!"
        >
            <p>
                Bitte melden Sie sich mit Ihrer Kunden- und einer Zählernummer
                an.<br />Sie finden diese Daten unter anderem auf Ihrer Rechnung
                oder der Ablesekarte.
            </p>
            <p>
                Wenn Sie mehrere Zählernummern haben, wählen Sie eine beliebige.
            </p>
        </page-section>
        <page-section hdl="Anmeldung">
            <page-auth-form />
        </page-section>
    </main>
</template>

<style lang="scss" scoped></style>
